<template>
  <v-container class="cmp-invoice-project-details-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <InvoiceProjectDetails :invoiceProjectDetails="invoiceProjectDetails" />
      <glayout
        :tabs="invoiceProjectSidewindowTabs"
        :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('general_settings')"
                h="356"
              >
                <General
                  :invoiceProjectDetails="invoiceProjectDetails"
                  @changed="onInvoiceProjectChanged"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('payment_terms')"
              >
                <PaymentTerms
                  :invoiceProjectDetails="invoiceProjectDetails"
                  @changed="onInvoiceProjectChanged"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('leading_text')"
              >
                <DBoxTextarea
                  :style="{ backgroundColor: 'white' }"
                  :value="
                    invoiceProjectDetails &&
                    invoiceProjectDetails.invoice_project &&
                    invoiceProjectDetails.invoice_project.leading_text
                  "
                  :id="'leading_text'"
                  @blur="(e) => onDBoxTABlur('leading_text', e)"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('trailing_text')"
              >
                <DBoxTextarea
                  :style="{ backgroundColor: 'white' }"
                  :value="
                    invoiceProjectDetails &&
                    invoiceProjectDetails.invoice_project &&
                    invoiceProjectDetails.invoice_project.trailing_text
                  "
                  :id="'trailing_text'"
                  @blur="(e) => onDBoxTABlur('trailing_text', e)"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="identities_invoice">
         
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('header')"
                  >
                    {{$t('save_header')}}
                  </button>
                </div>
              </gcol>
            </grow>
          
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('header')"
              >
                <div class="html-editor-container">
                  <HtmlEditor
                    v-if="
                      invoiceProjectDetails && !invoiceProjectDetails.loading
                    "
                    :value="invoiceProject.header"
                    @input="(value) => onInvoiceProjectUpdate('header', value)"
                  ></HtmlEditor>
                </div>
                <!-- <div
                  class="ut-flex"
                  style="
                    justify-content: flex-end;
                    margin-top: -40px;
                    padding: 10px;
                  "
                >
                  <button
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('header')"
                  >
                    Save Header
                  </button>
                </div> -->
              </gbox>
            </gcol>
          </grow>
          
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('footer')"
                  >
                    {{$t('save_footer')}}
                  </button>
                </div>
              </gcol>
            </grow>
          
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('footer')"
              >
                <div class="html-editor-container">
                  <HtmlEditor
                    v-if="
                      invoiceProjectDetails && !invoiceProjectDetails.loading
                    "
                    :value="invoiceProject.footer"
                    @input="(value) => onInvoiceProjectUpdate('footer', value)"
                  ></HtmlEditor>
                </div>
                <!-- <div
                  class="ut-flex"
                  style="
                    justify-content: flex-end;
                    margin-top: -40px;
                    padding: 10px;
                  "
                >
                  <button
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('footer')"
                  >
                    Save Footer
                  </button>
                </div> -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
  
        <gtab id="identities_cost_invoice" :title="$t('identities_cost_invoice')">
        
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('header_cost')"
                  >
                    {{$t('save_cost_header')}}
                  </button>
                </div>
              </gcol>
            </grow>
        
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('cost_header')"
              >
                <div class="html-editor-container">
                  <HtmlEditor
                    v-if="
                      invoiceProjectDetails && !invoiceProjectDetails.loading
                    "
                    :value="invoiceProject.header_cost"
                    @input="
                      (value) => onInvoiceProjectUpdate('header_cost', value)
                    "
                  ></HtmlEditor>
                </div>
                <!-- <div
                  class="ut-flex"
                  style="
                    justify-content: flex-end;
                    margin-top: -40px;
                    padding: 10px;
                  "
                >
                  <button
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('header_cost')"
                  >
                    Save Cost Header
                  </button>
                </div> -->
              </gbox>
            </gcol>
          </grow>
          
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('footer_cost')"
                  >
                    {{$t('save_cost_footer')}}
                  </button>
                </div>
              </gcol>
            </grow>
          
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('cost_footer')"
              >
                <div class="html-editor-container">
                  <HtmlEditor
                    v-if="
                      invoiceProjectDetails && !invoiceProjectDetails.loading
                    "
                    :value="invoiceProject.footer_cost"
                    @input="
                      (value) => onInvoiceProjectUpdate('footer_cost', value)
                    "
                  ></HtmlEditor>
                </div>
                <!-- <div
                  class="ut-flex"
                  style="
                    justify-content: flex-end;
                    margin-top: -40px;
                    padding: 10px;
                  "
                >
                  <button
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('footer_cost')"
                  >
                    Save Cost Footer
                  </button>
                </div> -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        
        <gtab id="identities_royalty_statement" :title="$t('identities_royalty_statement')">
          
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('header_royalty')"
                  >
                    {{$t('save_royalty_header')}}
                  </button>
                </div>
              </gcol>
            </grow>
          
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('royalty_header')"
              >
                <div class="html-editor-container">
                  <HtmlEditor
                    v-if="
                      invoiceProjectDetails && !invoiceProjectDetails.loading
                    "
                    :value="invoiceProject.header_royalty"
                    @input="
                      (value) => onInvoiceProjectUpdate('header_royalty', value)
                    "
                  ></HtmlEditor>
                </div>
                <!-- <div
                  class="ut-flex"
                  style="
                    justify-content: flex-end;
                    margin-top: -40px;
                    padding: 10px;
                  "
                >
                  <button
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('header_royalty')"
                  >
                    Save Royalty Header
                  </button>
                </div> -->
              </gbox>
            </gcol>
          </grow>
          
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('footer_royalty')"
                  >
                    {{$t('save_royalty_footer')}}
                  </button>
                </div>
              </gcol>
            </grow>
        
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('royalty_footer')"
              >
                <div class="html-editor-container">
                  <HtmlEditor
                    v-if="
                      invoiceProjectDetails && !invoiceProjectDetails.loading
                    "
                    :value="invoiceProject.footer_royalty"
                    @input="
                      (value) => onInvoiceProjectUpdate('footer_royalty', value)
                    "
                  ></HtmlEditor>
                </div>
                <!-- <div
                  class="ut-flex"
                  style="
                    justify-content: flex-end;
                    margin-top: -40px;
                    padding: 10px;
                  "
                >
                  <button
                    class="dt-button v5 s8"
                    @click="onSaveHtmlValue('footer_royalty')"
                  >
                    Save Royalty Footer
                  </button>
                </div> -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        
        <gtab
          id="identities_statement_email"
          :title="$t('identities_statement_email')"
        >
        
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveClassicClick()"
                  >
                   {{$t('save_btn')}}
                  </button>
                  
                </div>
                
              </gcol>
            </grow>
          
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('tab_title_classic_statement_email')"
              >
                <StatementEmailForm
                  @updated="onUpdateTextElement"
                  :invoiceProjectDetails="invoiceProjectDetails"
                />
              </gbox>
            </gcol>
            <gcol> </gcol>
          </grow>
          
            <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onPreviewClick()"
                  >
                    {{$t('preview_email')}}
                  </button>
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onSaveClick()"
                  >
                   {{$t('save')}}
                  </button>
                  
                </div>
                
              </gcol>
            </grow>
        
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="($t('email_text_logo') )"
              >
                <EmailTextForm
                  @updateTextElement="onUpdateTextElementSingle"
                  @updated="onUpdateTextElement"
                  :invoiceProjectDetails="invoiceProjectDetails"
                />
              </gbox>
            </gcol>
            <!-- <gcol>
               <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('email_logo')"
              > 
                <EmailLogoForm
                  @updated="onUpdateTextElement"
                  :invoiceProjectDetails="invoiceProjectDetails"
                />
               </gbox> 
            </gcol> -->
          </grow>
          <grow>
    
            <gcol>
              <!-- <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('email_logo')"
              > -->
                <EmailLogoForm
                  @updated="onUpdateTextElement"
                  :invoiceProjectDetails="invoiceProjectDetails"
                />
              <!-- </gbox> -->
            </gcol>
            <gcol></gcol>
          </grow>
        </gtab>
        <gtab
          id="identities_statement_invitation_email"
          :title="$t('tab_title_invitation_email')"
        >
        <grow>
              <gcol>
                <div style="padding-top: 10px;" class="ut-flex">
                  <!-- <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onPreviewClick()"
                  >
                    {{$t('preview_email')}}
                  </button> -->
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    @click="onInvitaionEmailSaveClick()"
                  >
                   {{$t('save')}}
                  </button>
                  
                </div>
                
              </gcol>
              <gcol></gcol>
            </grow>
          <grow>
            <gcol>
              <gbox
                :loading="invoiceProjectDetails && invoiceProjectDetails.loading"
                :title="$t('tab_title_invitation_email')"
              >
                <StatementEmailInvitationForm
                  @updated="onUpdateTextElementSingle"
                  :invoiceProjectDetails="invoiceProjectDetails"
                />
              </gbox>
            </gcol>
            
    
      <gcol>
        <EmailLogoInvitationForm
          @updated="onUpdateTextElement"
          :invoiceProjectDetails="invoiceProjectDetails"
        />
    
      </gcol>

       
      </grow>
          
          
        
    
       
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>
<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";

import InvoiceProjectDetails from "./invoice-project-details";
import EmailLogoForm from "./email-logo-form.vue";
import EmailTextForm from "./email-text-form.vue";
import EmailLogoInvitationForm from "./email-logo-invitation-form.vue";
import StatementEmailForm from "./statement-email-form.vue";
import StatementEmailInvitationForm from "./statement-email-invitation-form.vue";

import { mapGetters } from "vuex";
import DList from "@dtplugins/list/dlist";
import DBox from "@dtplugins/dbox/dbox";
import { mapKeyToAction } from "../../../../store/global";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import DBoxTextarea from "@/dt-plugins/dbox-textarea/dbox-textarea";

import General from "./general";
import PaymentTerms from "./payment-terms";
import { identitiesLDTRoutes } from "../../router/routes";
import HtmlEditor from "@plugins/html-editor/html-editor";
import { showNotification } from "../../../../dt-plugins/notification/notification.service";
import { NotificationService } from "@dtplugins/notification/notification.service";
export default {
  components: {
    InvoiceProjectDetails,
    DList,
    DBox,
    ModalContainer,
    DBoxTextarea,
    EmailLogoForm,
    EmailTextForm,
    StatementEmailForm,
    General,
    PaymentTerms,
    HtmlEditor,
    StatementEmailInvitationForm,
    EmailLogoInvitationForm
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("hideInvoices"),
    createModalMixin("hideArtistsFees"),
  ],
  data: function () {
    return {
      invoiceProjectEdit: {},
      text_element:this.invoiceProjectDetails?.invoice_project?.text_elements || {},
      text_element_classic:this.invoiceProjectDetails?.invoice_project?.text_elements || {}
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      invoiceProjectDetailsArray: "invoiceProjectDetails",
    }),
    invoice_project_id: function() {
      return this.$route.params.invoice_project_id;
    },
    invoiceProjectDetails: function() {
      const defaultValues = {};
      const selectedInvoiceProjectDetails =  (this.invoiceProjectDetailsArray || [])[this.invoice_project_id] || defaultValues;
      return { ...selectedInvoiceProjectDetails };
    },
    invoiceProjectSidewindowTabs: function () {
      return [
        { route: "overview", value:this.$t('company_setup') },
        { route: "identities_invoice", value: this.$t("identities_invoice") },
        {
          route: "identities_cost_invoice",
          value: this.$t("identities_cost_invoice"),
        },
        {
          route: "identities_royalty_statement",
          value: this.$t("identities_royalty_statement"),
        },
        {
          route: "identities_statement_email",
          value: this.$t("identities_statement_email"),
        },
        {
          route: "identities_statement_invitation_email",
          value: this.$t("tab_title_invitation_email"),
        },
        
      ];
    },
    invoiceProject: function () {
      return (
        this.invoiceProjectDetails?.invoice_project || {
          header: "",
          footer: "",
          header_cost: "",
          footer_cost: "",
          header_royalty: "",
          footer_royalty: "",
        }
      );
    },
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.Invoice_Project_Details.UPDATE.SINGLE,
      ActionTypes.InvoiceProjectDetails.UPDATE.SINGLE,
      ActionTypes.SelectedUser.UPDATE.SINGLE,
      ActionTypes.HIDE_USER_MODULE,
      ActionTypes.UPDATE_USER_DETAILS,
      ActionTypes.DELETE_HIDDEN_INVOICE_PROJECT,
      ActionTypes.DELETE_HIDDEN_ARTISTS_FEES,
      ActionTypes.MODIFY_INVOICE_PROJECT,
      ActionTypes.UPDATE_B2B_TEXT_ELEMENTS,
    ]),
    onCloseInvoiceProjectDetailsClick: function () {
      this.$emit("closed", true);
    },
    onUserChange: function (payload) {
      this[ActionTypes.SelectedUser.UPDATE.SINGLE](payload);
    },
    onUserModuleChange: function (payload) {
      this[ActionTypes.HIDE_USER_MODULE](payload);
    },
    onUpdateInvitationTextElement: function (payload) {
      this.onInvoiceProjectChanged({ name: 'share_invitation_email_data', value: payload.text_elements });
    },
    onUpdateTextElement: function (payload) {
      // console.log("payload0", payload);
      // this[ActionTypes.UPDATE_B2B_TEXT_ELEMENTS](payload);
      this.onInvoiceProjectChanged({ name: 'text_elements', value: payload.text_elements });
    },
    onAddHideInvoiceProject: function () {
      console.log("onAddHideInvoiceProject");
      openModalRoute(this, "hide_invoices");
    },
    onAddFeesForArtists: function () {
      console.log("onAddFeesForArtists");
      openModalRoute(this, "hide_artists_fees");
    },
    onHideComponentModal: function () {
      closeModalRoute(this);
    },
    onInvoiceProjectHide: function (payload) {
      this.onHideComponentModal();

      this[ActionTypes.UPDATE_USER_DETAILS]({
        name: "invoice_projects",
        value: payload,
      });
    },
    onInvoiceUnhide: function (item) {
      console.log(item);
      this[ActionTypes.DELETE_HIDDEN_INVOICE_PROJECT]({
        invoice_project_id: item.invoice_project_id,
        user_id: this.InvoiceProjectDetails.usr.user_id,
      });
    },
    onArtistUnhide: function (item) {
      this[ActionTypes.DELETE_HIDDEN_ARTISTS_FEES]({
        artist_id: item.artist_id,
        user_id: this.InvoiceProjectDetails.usr.user_id,
      });
    },
    onArtistsFeesHide: function (payload) {
      this.onHideComponentModal();

      this[ActionTypes.UPDATE_USER_DETAILS]({
        name: "artists",
        value: payload,
      });
    },
    onDBoxTABlur: function (name, event) {
      const value = event.target.value;
      // this[ActionTypes.Invoice_Project_Details.UPDATE.SINGLE]({ name, value });
      this.onInvoiceProjectChanged({ name, value });
    },
    onInvoiceProjectChanged: function ({ name, value }) {
      this[ActionTypes.InvoiceProjectDetails.UPDATE.SINGLE]({ name, value });
    },
    onSaveHeaderClick: function () {},
    onSaveFooterClick: function () {},
    onSaveHeaderCost: function () {},
    onSaveFooterCost: function () {},
    onSaveHeaderRoyalty: function () {},
    onSaveFooterRoyalty: function () {},
    onInvoiceProjectUpdate: function (key, value) {
      // console.log({"key, value": key, value});
      this.invoiceProjectEdit[key] = value;
    },
    onSaveHtmlValue: function (key) {
      if (this.invoiceProjectEdit.hasOwnProperty(key)) {
        showNotification(`${this.$dft.snakeCaseToWords(key)} Saved`);

        // this[ActionTypes.MODIFY_INVOICE_PROJECT]({
        //   name: key,
        //   value: this.invoiceProjectEdit[key],
        // });
        this.onInvoiceProjectChanged({ name: key, value: this.invoiceProjectEdit[key] });
      } else {
        showNotification("Nothing changed in " + key + ". No need to save");
      }
    },

    onPreviewClick:function(){
      let text_element_loc=Object.keys(this.text_element).length>0?this.text_element:this.invoiceProjectDetails?.invoice_project?.text_elements; 
      
      console.log(":::::::::::::::::",Object.keys(this.text_element).length,"::::::::::::::::::::::");
      let template =this.invoiceProjectDetails?.invoice_project?.b2b_email_template;
        template = template
          .replace(
            "[% b2b_email_leading_text %]",
            text_element_loc.b2b_leading || ""
          )
          .replace(
            "[% b2b_email_trailing_text %]",
            text_element_loc.b2b_trailing || ""
          )
          .replace("[% logo_url %]", text_element_loc.logo_url || "");

        let newWindow = window.open();
        newWindow.document.write(template);
    },
    onInvitaionEmailSaveClick:function(){
      let text_element_loc=Object.keys(this.text_element).length>0?this.text_element:this.invoiceProjectDetails?.invoice_project?.text_elements;
      
      this.onUpdateInvitationTextElement({
        text_elements: text_element_loc,
        invoice_project_id:this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
      });

        setTimeout(() => {
          NotificationService.showNotification({
            text: "Email Settings updated",
            timeout: 5000,
          });
        }, 10);

    },
    onSaveClick:function(){
      let text_element_loc=Object.keys(this.text_element).length>0?this.text_element:this.invoiceProjectDetails?.invoice_project?.text_elements;
      
      this.onUpdateTextElement({
        text_elements: text_element_loc,
        invoice_project_id:this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
      });

        setTimeout(() => {
          NotificationService.showNotification({
            text: "Email Settings updated",
            timeout: 5000,
          });
        }, 10);

    },
    onSaveClassicClick:function(){
      let text_element_loc=Object.keys(this.text_element).length>0?this.text_element:this.invoiceProjectDetails?.invoice_project?.text_elements;
      
      this.onUpdateTextElement({
        text_elements: text_element_loc,
        invoice_project_id:this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
      });

        setTimeout(() => {
          NotificationService.showNotification({
            text: "Email Settings updated",
            timeout: 5000,
          });
        }, 10);
    },

    onUpdateTextElementSingle:function(payload){
      this.text_element={...payload}
    }

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-invoice-project-details-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 119px);
  }
  .variable-table {
    width: 100%;
    padding: 5px;
    th {
      text-align: left;
    }
    tbody {
      td:first-child {
        // font-weight: 600;
      }
    }
    tr {
      height: 25px;
    }
  }

  .html-editor-container {
    height: 500px;
    overflow: auto;
    .ck-content {
      height: 400px;
    }
  }
}
</style>
